import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import classnames from 'classnames'
import Fade from 'react-reveal/Fade'

import { navigationShowModal, navigationHideModal } from 'action/navigation'

import ButtonStandard from 'view/component/generic/input/button-standard'
import { BsX } from 'react-icons/bs'

import styles from './index.scss'

class Modal extends React.Component {
  constructor (props) {
    super (props)

    if (this.props.message !== undefined && this.props.messageTitle !== undefined && this.props.children === undefined) {

      this.props.handleShowModal(
        <div className='d-flex flex-column p-2'>
          <div className='d-flex'>
            <h5 className='d-flex align-items-center flex-grow-1 m-0'>{this.props.messageTitle}</h5>
            <ButtonStandard onClick={this.props.handleHideModal} tertiary><BsX size='2rem' /></ButtonStandard>
          </div>,
          <div className='d-flex justify-content-between align-items-center flex-grow-1 pt-3'>
            <span className='py-2 pr-2 w-100'>{this.props.message}</span>
          </div>,
          <div className='d-flex justify-content-between align-items-center flex-grow-1 pt-3'>
            <ButtonStandard containerClassname='w-100' className='p-2 w-100' onClick={this.props.handleHideModal} primary>Ok</ButtonStandard>
          </div>
        </div>)

    }
  }

  render () {
    const {
      style,
      className,
      children,
      visible
    } = this.props

    return (
      <Fade>
        <div className={classnames(styles.overlay, 'd-flex position-fixed justify-content-center align-items-center w-100 h-100')}>
          <div className={classnames(styles.modalContainer, className)} style={style}>{children}</div>
        </div>
      </Fade>
    )
  }
}

export default connect(state => ({
}), dispatch => ({
  handleShowModal: bindActionCreators(navigationShowModal, dispatch),
  handleHideModal: bindActionCreators(navigationHideModal, dispatch)
}))(Modal)

